/**
 * Ссылка на мессенджер поддержки: логотип канала и его название.
 *
 * Кликабельно само название — ник рядом не печатается, поэтому над списком из одних
 * каналов стоит подсказка «(кликните на ссылку)». У номера телефона название — сам номер,
 * ссылка — tel:, и подсказка не нужна.
 */

import { PhoneIcon, TelegramIcon, WhatsappIcon } from "@/components/icons";
import type { SupportContact } from "@/constants/supportContacts";
import { cn } from "@/src/lib/utils";

/* У MAX логотипа в проекте нет — такой канал показывается одним названием. */
const CHANNEL_ICONS: Partial<Record<SupportContact["key"], typeof WhatsappIcon>> = {
  phone: PhoneIcon,
  whatsapp: WhatsappIcon,
  telegram: TelegramIcon,
};

const CHANNEL_COLORS: Partial<Record<SupportContact["key"], string>> = {
  phone: "text-muted-foreground",
  whatsapp: "text-[#25D366]",
  telegram: "text-[#229ED9]",
};

type SupportContactLinkProps = {
  contact: SupportContact;
  className?: string;
};

export function SupportContactLink({ contact, className }: SupportContactLinkProps) {
  const Icon = CHANNEL_ICONS[contact.key];
  /* tel: открывает звонилку, а не страницу: в новой вкладке от него остаётся пустая. */
  const external = contact.key !== "phone";

  return (
    <a
      href={contact.url}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      className={cn("flex items-center gap-3 text-sm font-bold", className)}
    >
      {Icon ? (
        <Icon size={22} className={cn("shrink-0", CHANNEL_COLORS[contact.key])} />
      ) : null}
      {contact.name}
    </a>
  );
}
